import { TESCookieV2 } from '../components/shared/cookies';
import { createAuthStrategy } from './auth-strategy';

/**
 * Job Ads Web Component Initialization
 * Initializes tesUi.jobAdsWebComponent with token strategy and UTM parameters
 * Note: tesUi is loaded globally via script tag in page.tsx
 *
 * Config (publicApiBaseUrl, jobsBaseUrl) is passed from server via data attributes
 * on the <tes-job-ads> element. This avoids window global dependencies and enables
 * environment-specific URLs to be hydrated directly from the server template.
 */

(function () {
  'use strict';

  
  function tryInitializeJobAds(config: { publicApiBaseUrl: string; jobsBaseUrl: string }) {
    const tesUi = (window as any).tesUi;
    if (!tesUi || !tesUi.jobAdsWebComponent || !tesUi.tokenStrategies) {
      return;
    }

    // Create token strategy from auth-strategy module
    const tokenStrategy = createAuthStrategy();
    if (!tokenStrategy) {
      console.warn('Failed to create token strategy');
      return;
    }

    const isUserLoggedIn = Boolean(TESCookieV2());
    const { publicApiBaseUrl, jobsBaseUrl } = config;

    // Set up UTM parameters for job ads
    const utmParams = new URLSearchParams({
      utm_source: 'teaching-resources',
      utm_medium: 'job_ad'
    }).toString();

    const jobsUrl = new URL('/jobs', jobsBaseUrl);
    jobsUrl.search = utmParams;

    const jobVacancyUrl = new URL('/jobs/vacancy/:id', jobsBaseUrl);
    jobVacancyUrl.search = utmParams;

    // Initialize the job ads web component
    tesUi.jobAdsWebComponent({
      apiBaseUrl: publicApiBaseUrl,
      tokenStrategy: tokenStrategy,
      personalisedForUser: isUserLoggedIn,
      seeMoreLinkUrl: jobsUrl.toString(),
      jobVacancyUrl: jobVacancyUrl.toString()
    });
  }

  function initializeJobAds() {
    const element = document.querySelector('tes-job-ads');
    if (!element) {
      return;
    }

    const publicApiBaseUrl = element.getAttribute('data-api-base-url');
    const jobsBaseUrl = element.getAttribute('data-jobs-base-url');

    if (!publicApiBaseUrl || !jobsBaseUrl) {
      console.warn('Job ads config missing from data attributes');
      return;
    }

    tryInitializeJobAds({ publicApiBaseUrl, jobsBaseUrl });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeJobAds, { once: true });
  } else {
    initializeJobAds();
    document.addEventListener('DOMContentLoaded', initializeJobAds, { once: true });
  }
})();
